<div class="schedule-options-container">
	<p>{{ 'repeat_every' | translate }}</p>
	<div class="repeat-selector-row">
		<mat-form-field
			hideRequiredMarker
			class="remove-number-arrow repeat-quantity no-label"
			subscriptSizing="dynamic"
		>
			<span class="number-control-prefix" (click)="decrementQuantity()">
				<mat-icon>remove</mat-icon>
			</span>
			<input
				#repeatNumberInput
				type="number"
				matInput
				class="amount-input-element"
				[ngModel]="optionsFormValue.interval"
				(ngModelChange)="numberInputChanged($event)"
			/>
			<span class="number-control-suffix" (click)="incrementQuantity()">
				<mat-icon>add</mat-icon>
			</span>
		</mat-form-field>
		<mat-form-field
			class="period-select no-label"
			hideRequiredMarker
			subscriptSizing="dynamic"
		>
			<mat-select
				[(value)]="optionsFormValue.period"
				(selectionChange)="selectedPeriodChange($event)"
			>
				@for (period of periods; track period) {
					<mat-option [value]="period.value">
						{{ period.name | translate }}
					</mat-option>
				}
			</mat-select>
		</mat-form-field>
	</div>
	<div class="period-content">
		@switch (optionsFormValue.period) {
			@case ('DAY') {
				<days-period-content
					[toggleValue]="optionsFormValue.excludeWeekends"
					(valueChanged)="toggleWeekends($event)"
				></days-period-content>
			}
			@case ('WEEK') {
				<weeks-period-content
					[selectedDays]="optionsFormValue.selectedDays"
					[selectedDaysError]="selectedDaysError"
					(valuesChanged)="changeFormValue('selectedDays', $event)"
				></weeks-period-content>
			}
			@case ('MONTH') {
				<months-period-content
					[selectedChoice]="optionsFormValue.monthSetup"
					(valueChanged)="changeFormValue('monthSetup', $event)"
				></months-period-content>
			}
		}
	</div>
</div>
